import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { baseUrl, customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config';
import { GET_SURGE_REPORT, GET_SURGE_REPORT_SUCCESS, GET_SURGE_REPORT_ERROR } from './../../actionType';
import cogoToast from 'cogo-toast';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant';

function* getSurgeReport({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/surge-report`,
      method: 'POST',
      headers: { Authorization: Constant?.CLIENT_TOKEN, ...customHeaders },
      data: payload?.data,
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      // cogoToast.success(response?.data?.message)
      yield put({ type: GET_SURGE_REPORT_SUCCESS, payload: response?.data });
    } else {
      // cogoToast.error(response?.response?.data?.message)
      yield put({ type: GET_SURGE_REPORT_ERROR, payload: response.error });
    }
  } catch (error) {
    yield put({ type: GET_SURGE_REPORT_ERROR, payload: error });
  }
}

export function* watchGetSurgeReport() {
  yield takeEvery(GET_SURGE_REPORT, getSurgeReport);
}

function* getSurgeReportSaga() {
  yield all([fork(watchGetSurgeReport)]);
}

export default getSurgeReportSaga;
